import { render, staticRenderFns } from "./documentosPdf.vue?vue&type=template&id=50d9ddf4&"
import script from "./documentosPdf.vue?vue&type=script&lang=js&"
export * from "./documentosPdf.vue?vue&type=script&lang=js&"
import style0 from "./documentosPdf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports